<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" outlined class="pl-2 pr-4" v-bind="attrs" v-on="on">
        <v-icon class="pr-2">$key</v-icon> {{ $t('profile.change_password') }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h5 text-capitalize">{{ $t('profile.change_password') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="validForm" ref="form">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="oldPassword"
                  :label="$t('profile.current_password')"
                  :rules="[rules.required, rules.min]"
                  :error-messages="hasOldPasswordError  ? oldPasswordError : []"
                  type="password"
                  class="mb-0 pb-0"
                  required/>
              </v-col>
              <v-col cols="12" sm="6" class="mb-0 pb-0">
                <v-text-field
                  v-model="newPassword"
                  :label="$t('profile.new_password')"
                  :rules="[rules.required, rules.min, rules.differentFromOld]"
                  :error-messages="hasNewPasswordError ? newPasswordError : []"
                  type="password"
                  required
                  />
              </v-col>
              <v-col cols="12" sm="6" class="mb-0 pb-0">
                <v-text-field
                  v-model="confirmPassword"
                  :label="$t('profile.confirm_password')"
                  :rules="[rules.required, rules.min, rules.matchingPasswords, rules.differentFromOld]"
                  :error-messages="hasNewPasswordError ? newPasswordError : []"
                  type="password"
                  class="mb-0 pb-0"
                  required/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">
          {{ $t('close') }}
        </v-btn>
        <v-btn color="blue darken-1" class="white--text" @click="changePassword" :disabled="!validForm">
          {{ $t('profile.change') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    validForm: false,
    dialog: false,
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    oldPasswordError: [],
    newPasswordError: [],
    hasOldPasswordError: false,
    hasNewPasswordError: false
  }),
  computed: {
    ...mapGetters(['scantrustAuthError', 'scantrustAuthErrorMessage']),
    rules () {
      return {
        required: v => !!v || this.$t('field_required'),
        min: v => v?.length >= 8 || this.$t('profile.min_characters', { num: 8 }),
        matchingPasswords: this.confirmPassword !== this.newPassword ? this.$t('profile.match_password') : true,
        differentFromOld: v => v !== this.oldPassword || this.$t('profile.new_password_different')
      }
    }
  },
  methods: {
    close () {
      this.dialog = false
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.newPasswordError = null
      this.oldPasswordError = null
      this.hasOldPasswordError = false
      this.hasNewPasswordError = false
    },
    async changePassword () {
      const obj = {
        old_password: this.oldPassword,
        new_password: this.newPassword,
        confirm_new_password: this.confirmPassword
      }
      await this.$store.dispatch('changePassword', obj)
      if (!this.scantrustAuthError) {
        this.dialog = false
        this.$refs.form.reset()
        this.$refs.form.resetValidation()
        this.$store.dispatch('showSnackBar', { message: this.$t('profile.password_changed') })
      } else {
        this.getErrors()
        this.dialog = true
      }
    },
    getErrors () {
      const errData = this.scantrustAuthErrorMessage
      if (errData.new_password) {
        this.newPasswordError = errData.new_password
        this.hasNewPasswordError = true
      }
      if (errData.old_password) {
        this.oldPasswordError = errData.old_password
        this.hasOldPasswordError = true
      }
    }
  },
  watch: {
    oldPassword () {
      if (this.oldPasswordError?.length && this.hasOldPasswordError) {
        this.oldPasswordError = []
      }
    },
    newPassword () {
      if (this.newPasswordError?.length && this.hasNewPasswordError) {
        this.newPasswordError = []
      }
    },
    confirmPassword () {
      if (this.newPasswordError?.length && this.hasNewPasswordError) {
        this.newPasswordError = []
      }
    }
  }
}
</script>
